import { type CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { useCreditCardStatementDetailsPresenter } from './useCreditCardStatementDetailsPresenter'
import { StatementDetailsPanel } from '../../views/StatementDetailsPanel'

export interface ICreditCardStatementDetailsPresenterProps {
  accountId: number
  /** FS owns the Reconcile modal (Modal-Free Feature Design) */
  onReconcileClick: (account: CreditCardAccount) => void
}

export const CreditCardStatementDetailsPresenter = ({
  accountId,
  onReconcileClick,
}: ICreditCardStatementDetailsPresenterProps) => {
  const { account } = useCreditCardStatementDetailsPresenter({ accountId })

  if (!account) return null

  return (
    <StatementDetailsPanel
      account={account}
      onReconcileClick={onReconcileClick}
    />
  )
}

CreditCardStatementDetailsPresenter.displayName =
  'CreditCardStatementDetailsPresenter'
